import React from 'react';
import { useTranslation } from 'react-i18next';
import { SelectButtonGroup, SelectButtonGroupProps } from './SelectButtonGroup';

type SelectButtonGroupYesNoProps = Omit<SelectButtonGroupProps, 'options' | 'value'> & { value?: boolean | null };

export const SelectButtonGroupYesNo = ({ value, ...props }: SelectButtonGroupYesNoProps) => {
	const { t } = useTranslation();
	return (
		<SelectButtonGroup
			{...props}
			options={[
				{ key: 'yes', label: t('misc.yes'), value: true, variant: 'primary' },
				{ key: 'no', label: t('misc.no'), value: false, variant: 'primary' },
			]}
			value={typeof value !== 'undefined' && value !== null ? value : null}
		/>
	);
};
